var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPanels(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_482_1153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 15C19.58 15 16 18.58 16 23C16 27.42 19.58 31 24 31C28.42 31 32 27.42 32 23C32 18.58 28.42 15 24 15Z",
    fill: "#1EB88B",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.68 12.5001L13.52 9.6801L9.92 6.1001L7.1 8.9201L10.68 12.5001ZM2 21.0001H8V25.0001H2V21.0001ZM22 1.1001H26V7.0001H22V1.1001ZM37.32 12.5101L34.5 9.6961L38.08 6.1161L40.892 8.9361L37.32 12.5101ZM34.48 36.3201L38.06 39.9201L40.88 37.1001L37.28 33.5201L34.48 36.3201ZM40 21.0001H46V25.0001H40V21.0001ZM24 11.0001C17.38 11.0001 12 16.3801 12 23.0001C12 29.6201 17.38 35.0001 24 35.0001C30.62 35.0001 36 29.6201 36 23.0001C36 16.3801 30.62 11.0001 24 11.0001ZM24 31.0001C19.58 31.0001 16 27.4201 16 23.0001C16 18.5801 19.58 15.0001 24 15.0001C28.42 15.0001 32 18.5801 32 23.0001C32 27.4201 28.42 31.0001 24 31.0001ZM22 39.0001H26V44.9001H22V39.0001ZM7.1 37.0801L9.92 39.9001L13.5 36.3001L10.68 33.4801L7.1 37.0801Z",
    fill: "#1EB88B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_482_1153"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanels);
export default __webpack_public_path__ + "static/media/panels.23e9b688bdf7cbdd1614a23b28c76957.svg";
export { ForwardRef as ReactComponent };